// extracted by mini-css-extract-plugin
export default {"addGramma":"Edit_addGramma__+DCz5","addForm":"Edit_addForm__7O2T8","formList":"Edit_formList__as2eq"};